<div class="rrhh-team-info-import-leader-container">
    <h1 class="heading-02-semi-bold">
      
      Se encontró el Team <span class="heading-02-bold">{{ value.teamName }}</span> del agente <span class="heading-02-bold">{{ value.leaderName }}</span>,
      <br>
      <br>
      <p class="rrhh-team-question">¿Desea vincular la estadística del Team?</p>
    </h1>
  </div>
  